// src/components/PriiLogo.js
// The Prii logo: the sunburst mark on its tile, and the wordmark. The mark is
// how Prii is spoken of; the wordmark is the name in Unbounded when a bar has
// room for it. Looks and motion live in PriiLogo.css; the tile matches the app
// icon (brand/build_icons.py) so the header and the home screen read as one
// object.
// Bundled, not fetched from Google: on a slow connection the wordmark fell back to a system font (iOS, 2026-10-19).
import '@fontsource/unbounded/800.css';
import mark from '../assets/brand/prii-mark.png';
import './PriiLogo.css';

const SIZES = {
  sm: { tile: 44, radius: 11, mark: 0.8, gap: 12, text: 26 }, // 56px header bar
  md: { tile: 50, radius: 12, mark: 0.8, gap: 14, text: 24 }, // 64px header bar
  lg: { tile: 80, radius: 19, mark: 0.8, gap: 22, text: 44 }, // OG card
};

export function PriiWordmark({ size = 'md', className = '' }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`prii-wordmark ${className}`} data-text="prii" style={{ fontSize: s.text }}>
      prii
    </span>
  );
}

export default function PriiLogo({ size = 'md', wordmark = false, bare = false }) {
  const s = SIZES[size] || SIZES.md;
  const markPx = Math.round(s.tile * s.mark);

  // bare: the transparent mark alone, at the tile's full size, with a breathing glow behind it (the app header,
  // operator 2026-09-23). The tile stays for the app icon and the OG card, where the mark needs a ground.
  if (bare) {
    return (
      <span className="inline-flex items-center" style={{ gap: s.gap }}>
        <span className="prii-mark-bare" style={{ width: s.tile, height: s.tile }}>
          <img src={mark} alt="" width={s.tile} height={s.tile} draggable={false} />
        </span>
        {wordmark && <PriiWordmark size={size} />}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center" style={{ gap: s.gap }}>
      <span className="prii-tile" style={{ width: s.tile, height: s.tile, borderRadius: s.radius }}>
        <img
          className="prii-tile__mark"
          src={mark}
          alt=""
          width={markPx}
          height={markPx}
          draggable={false}
        />
      </span>
      {wordmark && <PriiWordmark size={size} />}
    </span>
  );
}
